<template lang="pug">
.section
  .section-header
    template(v-if="isSubPage")
      .section-header-back
        a.btn.btn-sm.btn-icon(href="javascript:void(0)" @click="isPurchaseDomain(false)")
          i.fas.fa-arrow-left
      h1 {{ $t("ui.combine.purchase_domain") }}
      .section-header-breadcrumb
        .breadcrumb-item
          router-link(to="/domain/domainList") {{ $t("ui.domain_list") }}
        .breadcrumb-item.active
          span {{ $t('ui.combine.purchase_domain') }}
    template(v-else)
      h1 {{ $t("ui.domain_list") }}
  .section-body
    .row
      .col-12
        template(v-if="!isOperator")
          domainList
        template(v-else)
          domainOp(ref="domainOp" @click="isPurchaseDomain" :isPurchaseDomain="isSubPage")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import domainList from "@/components/domain/domainList.vue";
import domainOp from "@/components/domain/domainOp.vue";

export default {
  components: {
    domainList,
    domainOp
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    isSubPage: false
  }),
  computed: {
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    }
  },
  mounted: function() {},
  methods: {
    isPurchaseDomain(e) {
      this.isSubPage = e
    }
  }
};
</script>